<template>
  <refonte-modal
    v-bind:show="props.show"
    class="!max-w-[1200px]"
    v-on:close="close">
    <template v-slot:modalHeader>
      <h1 class="px-6 text-3xl font-bold text-core-600">
        {{ titre }}
      </h1>
    </template>
    <template v-slot:modalBody>
      <div v-if="loading">
        <spinner
          sizes="w-20 h-20"
          thickness="border-8" />
      </div>
      <div
        v-else
        class="mb-4 flex w-full flex-wrap lg:px-6">
        <div
          class="mb-4 flex w-full border-l-1 pl-3 text-lg leading-none text-accent-500"
          v-if="module_elearning.dateDebutAcces && plateforme_duree_acces">
          {{
            `Accessible pendant ${plateforme_duree_acces} jour${plateforme_duree_acces > 1 ? 's' : ''} ${!module_elearning.showRetractation ? `à compter du ${module_elearning.dateDebutAcces} et jusqu'au ${module_elearning.dateFinAcces}` : ''}`
          }}
        </div>
        <message-box
          class="w-full text-justify font-bold"
          v-if="autoriser_question && questions.length < 2"
          v-bind:source="`
                       <p class='mb-1.5'>Pendant la période de validité de la formation, vous pouvez poser jusqu’à 2 questions sur le contenu du module elearning. Les réponses apportées seront visibles dans votre espace participant.</p>
                       <p>Attention la question ne doit pas être une consultation sur un problème rencontré dans un dossier client.</p>
                       `" />

        <div
          class="mb-4 flex w-full flex-wrap"
          v-if="autoriser_question && questions.length < 2">
          <div class="mb-2 flex w-full text-lg">
            <refonte-textarea
              label=""
              v-bind:maxlength="1000"
              name="question"
              autogrow
              placeholder="Motif"
              input_class="w-full"
              class="no-box w-full"
              v-bind:value="question"
              v-on:input="setQuestion($event)" />
          </div>
          <div class="flex w-full justify-between">
            <div class="flex items-center">
              {{ questions.length }}/2 questions
            </div>

            <button
              class="w-56 rounded bg-blue-600 px-4 py-3 font-bold text-white hover:bg-blue-500"
              v-on:click="sendQuestion">
              Enregistrer
            </button>
          </div>
        </div>
        <hr
          class="my-2 mb-4 flex w-full text-lg text-core-900 opacity-50"
          v-if="autoriser_question && questions.length == 1" />
        <div
          class="my-4 flex w-full flex-wrap rounded-lg border border-accent-300 bg-accent-100 px-6 shadow-lg"
          v-if="questions.length">
          <div
            class="flex w-full flex-wrap py-4"
            v-for="(q, index) in questions"
            v-bind:key="q.id">
            <div class="flex w-full flex-wrap space-y-1 py-2">
              <div class="flex w-full font-bold">Question {{ index + 1 }}</div>
              <div class="flex w-full pl-2">{{ q.question }}</div>
            </div>
            <div
              v-if="q.reponse"
              class="flex w-full flex-wrap space-y-1 py-2">
              <div class="flex w-full font-bold">Réponse {{ index + 1 }}</div>
              <div class="flex w-full pl-2">{{ q.reponse }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import spinner from '@/components/utils/spinner.vue';
  import { ref } from 'vue';
  import { API } from '@/http-common';
  import messageBox from '@/components/utils/message-box.vue';
  import { headerSkipRedirection } from '@/mixin/api_utils';
  import RefonteTextarea from '@/components/refonte/inputs/refonte-textarea.vue';
  const props = withDefaults(
    defineProps<{
      show: boolean;
      titre: string;
      on_close: Function;
      class?: string;
      module_elearning: Object;
      questions: Object[];
      autoriser_question: Boolean;
      plateforme_duree_acces: Number;
      elearning_participant_id: Number;
      fetch_formation_detail: Function;
    }>(),
    {
      class: ''
    }
  );

  function close() {
    props.on_close();
  }

  const loading = ref(false);
  const question = ref<string>('');

  const setQuestion = (value) => {
    question.value = value;
  };
  const sendQuestion = async () => {
    loading.value = true;
    await API.post(
      `participant/elearning/${props.elearning_participant_id}/question`,
      { question: question.value },
      { ...headerSkipRedirection }
    );
    await props.fetch_formation_detail();
    question.value = '';
    loading.value = false;
  };
</script>

<style lang="scss" scoped>
  #convocation {
    :deep(a[href]) {
      @apply cursor-pointer text-jinius-dark-green hover:underline #{!important};
    }
  }

  .label {
    @apply cursor-pointer px-4 font-normal hover:font-bold hover:text-jinius-green;
    &.active {
      @apply font-bold text-jinius-green;
    }
  }
</style>
